import React from 'react'

const stopPropagation = event => event.stopPropagation()

const ItineraryButtonContainer = ({ className, children }) => (
  <div className={className} onClick={stopPropagation}>
    {children}
  </div>
)

export default ItineraryButtonContainer
